import {Component, Injector, Input, OnInit} from '@angular/core';
import {DynamicBarService} from "../../../_components/dynamic-bar/dynamic-bar.service";


@Component({
    selector: 'nivelaciones-alumno-barra',
    standalone: false,
    template: `
        <div class="header-mainInfo">
            <a class="control-item" href="/nivelaciones" title="Ir a nivelaciones">Nivelaciones</a>
            <span class="header-mainInfo__separator">/</span>
            <h1 class="">Mis nivelaciones</h1>
            <span class="spacer"></span>
        </div>`
})

export class NivelacionesAlumnoBarraComponent implements OnInit {


    constructor(private dynamicBarService: DynamicBarService) {
    }

    ngOnInit() {

    }
}